import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { DatePicker } from 'react-tempusdominus-bootstrap';
import moment from 'moment';
import SimpleTable from '../../../../Components/SimpleTable';
import Loading from '../../../../Components/Loading';
import { useTripsByDateState, getTripsByDate, useAccountState, getTripSettings } from '../../../../Context';
import { getCustomerDetails } from '../../../../config';

const DATE_FORMAT = 'MM-DD-YYYY';
const BACK_TO_TRIPS_BY_DATE = `backTo=${encodeURIComponent('Trips by Date')}&backUrl=${encodeURIComponent('/trips-by-date')}`;

const TripsByDate = ({ history }) => {
    const {
        tripsByDateDispatch,
        tripsByDate: { trips, loading, errorMessage },
    } = useTripsByDateState();
    const {
        AccountsDispatch,
        tripSettings: { tripSettings },
    } = useAccountState();
    const [selectedDate, setSelectedDate] = useState(moment());

    useEffect(() => {
        if (!getCustomerDetails()?.cpEnableTripsByDate) history.replace('/bookings');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getTripSettings(AccountsDispatch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [AccountsDispatch]);

    useEffect(() => {
        getTripsByDate(tripsByDateDispatch, selectedDate.format('YYYY-MM-DD'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tripsByDateDispatch, selectedDate]);

    useEffect(() => {
        if (errorMessage) history.replace('/bookings');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorMessage]);

    const onRowClick = (item) => {
        history.push(
            `/bookings-vehicle-assignment/${item.vehicleAssignmentID}?bookingId=${item.bookingID}&${BACK_TO_TRIPS_BY_DATE}`
        );
    };

    const renderBookingId = (item) => (
        <span
            className="text-primary cursor-pointer"
            style={{ textDecoration: 'underline' }}
            onClick={(e) => {
                e.stopPropagation();
                history.push(`/bookings/${item.bookingID}?${BACK_TO_TRIPS_BY_DATE}`);
            }}
        >
            {item.bookingFormattedID}
        </span>
    );

    const showDriverColumns = trips.some((trip) => !trip.driverInfoGated);
    const pendingThresholds = [
        ...new Set(trips.filter((trip) => trip.driverInfoPending).map((trip) => trip.driverInfoThresholdHours)),
    ];

    const fieldNames = [
        ['bookingFormattedID', 'Booking ID', renderBookingId],
        ['groupName', 'Group Name'],
        ['tripReference', 'Trip Reference'],
        ['routeDescription', 'Route Description'],
        ...(showDriverColumns
            ? [
                  ['driverFullName', 'Driver Name'],
                  ['driverPhone', 'Driver Phone Number'],
                  ['vehicleId', 'Vehicle ID'],
              ]
            : []),
        ['firstDeparture', 'First Departure'],
        ['firstPickupLocation', 'First Pick Up Location'],
        ['destination', 'Destination'],
    ];

    return tripSettings ? (
        <div className="p-2">
            <div className="d-flex align-items-center mb-2">
                <Button variant="link" onClick={() => setSelectedDate((prev) => moment(prev).subtract(1, 'day'))}>
                    <i className="fa fa-chevron-left" />
                </Button>
                <label className="test mb-0">
                    <DatePicker
                        date={selectedDate.format(DATE_FORMAT)}
                        onChange={(e) => e.date && setSelectedDate(e.date)}
                    />
                </label>
                <Button variant="link" onClick={() => setSelectedDate((prev) => moment(prev).add(1, 'day'))}>
                    <i className="fa fa-chevron-right" />
                </Button>
            </div>
            {!loading &&
                pendingThresholds.map((hours) => (
                    <p key={hours} className="text-muted font-italic mb-2">
                        Driver information will be displayed {hours} hours before departure time.
                    </p>
                ))}
            <SimpleTable
                fieldNames={fieldNames}
                data={trips}
                mainColor={tripSettings?.mainColor}
                bordered={true}
                loading={loading}
                onClick={onRowClick}
            />
        </div>
    ) : (
        <Loading loading={loading} />
    );
};

export default TripsByDate;
